const OFP_GLASSES = [
  "None",
  "Spectacles",
  "Sunglasses",
];

export default OFP_GLASSES;